import React, { useEffect, useState } from "react";
import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import {
  deleteBlock,
  resetDeletBlock,
} from "../../../../../redux/slices/block/deleteBlockSlice";

import useFetchBlock from "../../../../../hooks/useFetchBlock";
import ConfirmModal from "../../../../../components/dashboard/modal/Confirm";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";

import SpinnerGiff from "../../../../../assets/spinner.svg";
import i18nForComponent from "../../../../../locales/component/i18nForComponent";
import { I18nextProvider } from "react-i18next";

const EditQrCode = () => {
  const { darkMode } = useSelector((state) => state.theme);

  const { translate, tComponent, allLangs, handleLanguageChange } =
    useLocales();
  const { setActiveMainPageNav } = useStateContext();
  const { themeDirection } = useSettings();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { optionId } = useParams();
  useEffect(() => {
    setActiveMainPageNav(true);

    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  const baseUrl = process.env.REACT_APP_API_URL;
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user.userid;
  const usertoken = user.token;
  const linkId = localStorage.getItem("linkId");
  const [prevData, setPrevData] = useState(null);
  const url = baseUrl + "/api/user/getOption/" + userId + "/" + optionId;

  const { data, loading, error } = useFetchBlock(url);

  useEffect(() => {
    if (prevData?.coloum_value) {
      if (prevData?.language) {
        setSelectedLang(prevData?.language);
        const matchedLang = allLangs?.find(
          (lang) => lang.value === prevData?.language
        );
        const shouldSetLang = matchedLang?.label;
        setSelectedReporterType(shouldSetLang);
        handleLanguageChange(prevData?.language);
      }
    }

    setPrevData({
      ...data?.data,
      coloum_value:
        data?.data?.coloum_value && JSON.parse(data?.data?.coloum_value),
    });
    if (error) {
      toast.error("Something went wrong...");
    }
  }, [prevData, data, error]);

  const linkListData = {
    userId,
    usertoken,
    linkId,
  };

  const [subLoader, setSubLoader] = useState(false);
  const handleShareSubmit = () => {
    navigate("/dashboard/component");
  };

  const fetchingLinksList = () => {
    dispatch(gettingLinkList(linkListData));
  };
  const deleteHandler = async () => {
    const obj = {
      optionId: optionId,
      userId: userId,
    };
    setSubLoader(true);
    await dispatch(deleteBlock(obj)).then(() => {});
    setSubLoader(false);
  };

  const {
    DeleteBlock,
    isDeleteBlockError,
    isDeleteBlockSuccess,
    isDeleteBlockLoading,
  } = useSelector((state) => state?.deleteBlock);

  useEffect(() => {
    if (DeleteBlock?.data?.status === "success" && isDeleteBlockSuccess) {
      toast.success(DeleteBlock?.data?.message);
      fetchingLinksList();
      navigate("/dashboard/component");
    }
    if (DeleteBlock?.data?.status === "failed" && isDeleteBlockSuccess) {
      toast.error(DeleteBlock?.data?.message);
    }
    if (isDeleteBlockError) {
      navigate("/500");
    }
    dispatch(resetDeletBlock());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteBlockLoading, DeleteBlock]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDeleteModal = () => {
    deleteHandler();
    setIsModalOpen(false);
  };

  return (
    <>
      <ConfirmModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onConfirm={handleDeleteModal}
        selectedLang={prevData?.language}
      />
      {loading && (
        <div
          style={{ zIndex: "999999" }}
          className="fixed inset-0 h-screen bg-[#ffffffa7] pt-5 flex justify-center items-center overflow-hidden"
        >
          <img src={SpinnerGiff} alt="..." />
        </div>
      )}
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="dark:text-color_v1_dark"> {translate("Qr_code")} </p>
          </div>
        </Link>
      </div>
      <I18nextProvider i18n={i18nForComponent}>
        <div
          className="pt-[50px] md:px-0 pb-6 sm:pt-[28px] px-6"
          style={{
            direction: selectedLang === "ar" ? "rtl" : "ltr",
          }}
        >
          <div className="border rounded-[10px] border-light_bg_v2 bg-light_bg_v5 p-6 sm:p-[25px] dark:bg-dark-secondary dark:border-color_dark">
            <div className="flex justify-between items-center  mb-[20px] sm:mb-[25px]">
              <p className="text-small2_b sm:text-small1_bold text-heading_color dark:text-color_v1_dark">
                {tComponent(`qr_code.edit`)} {tComponent("qr_code.Qr_code")}
              </p>
              <div
                className={`w-[100px] bg-light_bg_v4 capitalize p-[10px] text-small2 lg:text-body_copy2 rounded-md flex justify-center items-center`}
              >
                {selectedReporterType ? selectedReporterType : "English"}
              </div>
            </div>
            <div className="bg-light_bg_v4 rounded-lg p-10 sm:p-[30px]">
              <div className="flex items-center justify-center w-full">
                <img src={prevData?.coloum_value?.qr} alt="" />
              </div>
            </div>
            <div className="flex mt-[26px] items-center justify-end">
              <button
                onClick={() => setIsModalOpen(true)}
                className="flex justify-center items-center"
              >
                {darkMode ? <TrashIconDark /> : <TrashIcon />}
                <p className="ps-1.5 pt-1 text-small3_b gray-700 text-heading_color dark:text-color_v1_dark">
                  {tComponent("qr_code.delete_cap")}
                </p>
              </button>
              <ExtraSmallFilledButton
                name={`${tComponent("qr_code.save_cap")}`}
                buttonType={"button"}
                isLoading={subLoader}
                onClickHandler={handleShareSubmit}
                classes={"ms-3"}
              />
            </div>
          </div>
        </div>
      </I18nextProvider>
    </>
  );
};

export default EditQrCode;
